import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from 'src/app/Core/services/language.service';

@Component({
  selector: 'app-passcode-input',
  templateUrl: './passcode-input.component.html',
  styleUrls: ['./passcode-input.component.scss'],
})
export class PasscodeInputComponent {
  @Input('label') label: string = '';
  hidden: boolean = true;
  @Input() currentValue: string = '';
  @Input() length: number = 6;
  @Output() currentValueChange: EventEmitter<string | false> = new EventEmitter<
    string | false
  >();
  passcode = new Array(length).fill('');
  oneIntegerPattern = new RegExp('^[0-9]{1}$');
  constructor(private languageService: LanguageService) {}

  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }

  emitOrNext(index: number, event: Event) {
    let val = (event as InputEvent).data || '';

    val = val.replace(/[^\d]+/g, '');
    (
      document.getElementById(
        'cet-passcode-' + index + this.label.split(' ')[0]
      ) as HTMLInputElement
    ).value = val;
    this.passcode[index] = val;
    if (val) {
      let next = document.getElementById(
        'cet-passcode-' + (index + 1) + this.label.split(' ')[0]
      );

      if (index == 5) {
        document
          .getElementById('cet-passcode-' + index + this.label.split(' ')[0])
          ?.blur();
      } else next?.focus();
    }
    this.emitCurrentValue();
  }

  emitOrPrev(index: number) {
    if (index == 0) {
      this.passcode[0] = '';
    } else {
      let prev = document.getElementById(
        'cet-passcode-' + (index - 1) + this.label.split(' ')[0]
      );
      // this.passcode[index] = '';
      prev?.focus();
    }
    this.emitCurrentValue();
  }

  emitCurrentValue() {
    let val = this.passcode.join('');
    if (val.trim().length == this.length) {
      return this.currentValueChange.emit(val);
    }
    return this.currentValueChange.emit(false);
  }
}
